<div class="form-section">
  <div class="section-header">
    <div class="section-label">
      <span class="section-num">05.A</span>
      <span class="section-title">Pre-save simulation</span>
    </div>
    <span class="section-hint">{{ totalConfigItems }} changes across 3 engines</span>
  </div>

  <div class="simulation-stats">
    <div class="sim-stat sim-stat--revalidate">
      <span class="sim-stat-label">Will revalidate</span>
      <span class="sim-stat-value">0</span>
    </div>
    <div class="sim-stat sim-stat--attention">
      <span class="sim-stat-label">Need attention</span>
      <span class="sim-stat-value">0</span>
    </div>
    <div class="sim-stat sim-stat--fail">
      <span class="sim-stat-label">Will fail</span>
      <span class="sim-stat-value">0</span>
    </div>
  </div>

  <p class="simulation-note">
    This is a new channel with no existing POS. After creation, any POS created in this channel
    will be validated against the configured rules. No existing data will be affected.
  </p>
</div>

<div class="section-divider"></div>

<div class="form-section">
  <div class="section-header">
    <div class="section-label">
      <span class="section-num">05.B</span>
      <span class="section-title">Change diff</span>
    </div>
    <span class="section-hint">By engine</span>
  </div>

  <div class="diff-section">
    <div class="diff-header">
      <span>Channel identity</span>
      <span class="diff-count">{{ formData.name ? '2 set' : '0 set' }}</span>
    </div>
    @if (formData.name || formData.code) {
    <div class="diff-body">
      @if (formData.name) {
        <div class="diff-row diff-row--added">+ Name: <strong>{{ formData.name }}</strong></div>
      }
      @if (formData.code) {
        <div class="diff-row diff-row--added">+ Code: <strong>{{ formData.code }}</strong></div>
      }
      @if (formData.description) {
        <div class="diff-row diff-row--added">+ Description set</div>
      }
      <div class="diff-row diff-row--added">+ Lifecycle: <strong>{{ formData.active ? 'Active' : 'Inactive' }}</strong></div>
    </div>
    }
  </div>

  @if (fieldRules.length > 0) {
  <div class="diff-section">
    <div class="diff-header">
      <span>Field rules</span>
      <span class="diff-count">{{ fieldRules.length }} configured</span>
    </div>
    <div class="diff-body">
      @for (rule of fieldRules; track rule.id) {
        <div class="diff-row diff-row--added">
          + Required: <strong>{{ rule.fieldName }}</strong>
          @if (rule.conditionalLogic) { when {{ rule.conditionalLogic }} }
        </div>
      }
    </div>
  </div>
  }

  @if (linkedSurveys.length > 0) {
  <div class="diff-section">
    <div class="diff-header">
      <span>Surveys</span>
      <span class="diff-count">{{ linkedSurveys.length }} linked</span>
    </div>
    <div class="diff-body">
      @for (survey of linkedSurveys; track survey.id) {
        <div class="diff-row diff-row--added">+ Linked: <strong>{{ survey.name }}</strong></div>
      }
    </div>
  </div>
  }

  @if (skuRules.length > 0) {
  <div class="diff-section">
    <div class="diff-header">
      <span>SKU rules</span>
      <span class="diff-count">{{ skuRules.length }} configured</span>
    </div>
    <div class="diff-body">
      @for (rule of skuRules; track rule.id) {
        <div class="diff-row diff-row--added">
          + {{ rule.type }}: <strong>{{ rule.code }}</strong> — {{ rule.label }}
        </div>
      }
    </div>
  </div>
  }
</div>
